<template>

  <!-- Cell Takt -->
  <table class="takt-table" v-if="cellTaktScans && cellTaktScans.length">
    <thead>
      <tr class="trhead">
        <th>Céllule <b>{{ cellID }}</b></th>
        <th>Commande</th>
        <th v-for="index in this.maxOperatorsOnCell">Opérateur {{ index }}</th>
        <th>TTM</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td rowspan="0">
          <b-button style="margin-bottom: 30px;" :disabled="currentTicketIndex==0" @click="()=>{this.currentTicketIndex = 0}">
            Début
          </b-button>
          <i class="previous-next-cmd">{{ nextTicketScans }}</i>
          <br/>
          <b-button style="margin-bottom: 10px;" :disabled="!nextTicketScans" @click="()=>{this.currentTicketIndex--}">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
          </b-button>
          <br>
          <b-button style="margin-top: 10px;" :disabled="!previousTicketScans" @click="()=>{this.currentTicketIndex++}">
            <i class="fa fa-arrow-down" aria-hidden="true"></i>
          </b-button>
          <br />
          <i class="previous-next-cmd">{{ previousTicketScans }}</i>
        </td>
      </tr>
      <tr v-for="(ticketScans, tIndex) in lastFourTickets">
        <td>
          <p class="current-cmd">{{ getTicketName(tIndex)}}</p>
        </td>
        <td v-for="(scan, index) in ticketScans" :key="index">
          <div v-if="scan.cmd_id">
            <b-card
              :header="scan.final_time ? 'Terminé' : 'En cours'"
              class="takt-card"
              :header-bg-variant="scan.final_time ? 'info' : 'warning'"
              border-variant="Light"
              align="center"
            >
              <b-card-text v-if="scan.final_time">
                <p class="takt-text">{{ Math.ceil(scan.final_time / 60) }}</p>
                <i class="min-text">min(s)</i>
              </b-card-text>
              <b-card-text v-else>
                <p class="takt-text">{{ Math.ceil(scan.elapsed_time / 60) }}</p>
                <i class="min-text">min(s)</i>
              </b-card-text>
            </b-card>
          </div>
          <div v-else>
            --
          </div>
        </td>
        <td class="takt-text">
          <p class="takt-text">{{ averageTicketTakt(tIndex) }}</p>
          <i class="min-text">min(s)</i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'CellTakt',
  props: ['cellID', 'cellTaktScans'],
  data() {
    return {
      currentTicketIndex: 0,
      maxOperatorsOnCell: 0
    }
  },
  computed: {
    lastFourTickets: function() {
      this.maxOperatorsOnCell = 0
      let displayedTickets = []
      this.cellTaktScans.slice(this.currentTicketIndex, Math.min(this.cellTaktScans.length, this.currentTicketIndex + 4)).forEach(scan => {
        this.maxOperatorsOnCell = Math.max(this.maxOperatorsOnCell, scan.length)
        displayedTickets.push(scan.reverse())
      })
      displayedTickets.forEach(scan => {
        while (scan.length < this.maxOperatorsOnCell) {
          scan.push({})
        }
      })

      return displayedTickets
    },

    previousTicketScans: function() {
      let result = 'chargement'
      if (
        this.cellTaktScans.length &&
        this.cellTaktScans[this.currentTicketIndex + 4]
      ) {
        result = this.cellTaktScans[this.currentTicketIndex + 4][0].cmd_id
      } else {
        result = ''
      }
      return result
    },

    nextTicketScans: function() {
      let result = 'chargement'
      if (
        this.cellTaktScans.length &&
        this.cellTaktScans[this.currentTicketIndex - 1]
      ) {
        result = this.cellTaktScans[this.currentTicketIndex - 1][0].cmd_id
      } else {
        result = ''
      }
      return result
    }
  },

  methods: {
    getTicketName : function(index) {
      let result = 'chargement'
      if (
        this.cellTaktScans.length &&
        this.cellTaktScans[this.currentTicketIndex + index]
      ) {
        result = this.cellTaktScans[this.currentTicketIndex + index][0].cmd_id
      }
      else {
        result = ''
      }
      return result
    },

    averageTicketTakt: function(index) {
      if (this.cellTaktScans.length) {
        let cumul = 0
        let count = 0
        this.cellTaktScans[this.currentTicketIndex + index].forEach(scan => {
          if (scan.final_time) {
            count++
            cumul += scan.final_time
          }
        })
        if (count) {
          const avg_duration = cumul / count
          return Math.ceil(avg_duration / 60)
        } else {
          return '...'
        }
      }
    },
  }
}
</script>

<style scoped>

.takt-table {
  width: 95%;
  display: table;
}
.trhead {
  background-color: rgb(235, 239, 241) !important;
  height: 30px !important;
  border-top: solid 1px lightgray;
}
.button-column {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.takt-card {
  /* width: 140px; */
  display: inline-block;
  padding: 0 !important;
  margin-top: 5px;
}

.first-cell,
.takt-text {
  font-size: 1.5rem;
}
.min-text {
  font-size: 0.5rem;
  margin-bottom: 0px;
}

.previous-next-cmd {
  display: block;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 0.8rem;
}
.current-cmd {
  color: rgb(74, 121, 160);
  font-weight: bold;
}
.first-col {
  width: 1% !important;
}
.middle-col {
  width: 98%;
}
.last-col {
  width: 1% !important;
}
tr {
  position: relative;
  line-height: 1px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/andon/cell_takt.vue